<template>
  <Card :btnMsg="$t('channelSelect.btn_text')" @changeStep="changeStep" :prevStepName="'uploadPic'" :embedded="embedded" :disabled="channelLoading || submitting || !channelList.length">
    <div class="card-channelSelect">
      <div class="card-content">
        <p class="card-title" v-html="$t('channelSelect.title')"></p>
        <p class="card-text" v-html="$t('channelSelect.text')"></p>

        <div v-if="channelLoading" class="channel-loading"><van-loading size="24px" color="#0ea5e9" /></div>
        <div v-else-if="!channelList.length" class="channel-empty">{{ $t('networkErrorText') }}</div>

        <div v-if="channelList.length" class="card-swipe">
          <!-- 轮播图部分 -->
          <van-swipe ref="mySwipe" @change="changeSwipeIdx" indicator-color="#f4a300">
            <van-swipe-item v-for="item in channelList" :key="item.id">
              <img :src="item.channel_pic" alt="Gift" class="card-image" />
            </van-swipe-item>
          </van-swipe>
          <!-- 左右箭头 -->
          <van-button class="swipe-arrow prev-arrow" @click="prev">
            <van-icon class="arrow" name="arrow-left" />
          </van-button>
          <van-button class="swipe-arrow next-arrow" @click="next">
            <van-icon class="arrow" name="arrow" />
          </van-button>
        </div>
      </div>

      <div class="card-footer">
        <p class="footer-note" v-html="$t('channelSelect.footer')"></p>
      </div>
    </div>
  </Card>
</template>

<script>
import Card from '@/components/card.vue';
import {postSubmit,postChannelList} from '@/api/portal';
export default {
  components: {
    Card,
  },
  props: {
    embedded: { type: Boolean, default: false },
    value: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: {},
      channelList:[],
      channelLoading: false,
      submitting: false,
      currentIndex: 0,
      jumpMap:{
        'address':'cityForm',
        'email':'thanksAll',
        'account':'paypalForm',
      }
    };
  },
  async mounted() {
    this.form = this.value;
    await this.getChannelList();
  },
  methods: {
    async getChannelList(){
      this.channelLoading = true;
      try {
        const res = await postChannelList({
          order_id: this.form.order_id,
          email: this.form.email,
        });
        this.channelList = Array.isArray(res.data) ? res.data : [];
        this.currentIndex = this.channelList.length
          ? Math.min(this.form.currentIndex || 0, this.channelList.length - 1)
          : 0;
        this.$nextTick(() => this.swipeToByIndex(this.currentIndex));
      } catch (error) {
        this.channelList = [];
        this.$toast.fail(this.$t('networkErrorText'));
      } finally {
        this.channelLoading = false;
      }
    },
    prev() {
      if (this.$refs.mySwipe) this.$refs.mySwipe.prev();
    },
    next() {
      if (this.$refs.mySwipe) this.$refs.mySwipe.next();
    },
    changeSwipeIdx(v) {
      this.currentIndex = v;
    },
    swipeToByIndex(index) {
      if (this.$refs.mySwipe) this.$refs.mySwipe.swipeTo(index);
    },
    prevStep(stepName) {
      this.$emit('prevStep', stepName);
    },
    changeStep() {
      let item = this.channelList[this.currentIndex];
      if (!item) {
        this.$toast.fail(this.$t('networkErrorText'));
        return;
      }
      this.form.channel_id = item.id;
      this.form.channel_type = item.channel_type;
      this.form.channel_pic = item.channel_pic;
      this.$parent.selectedGift = item;
      // channel_type address 实体礼物
      // channel_type email 邮件
      // channel_type account paypal
      this.$emit('input', {...this.form,currentIndex:this.currentIndex});
      if (this.jumpMap[item.channel_type]) {
       if( item.channel_type === 'email' ){
          this.submitting = true;
          postSubmit(
            {
              order_id: this.form.order_id,
              area_id: this.form.area_id,
              channel_id: this.form.channel_id,
              nick_name: this.form.nick_name,
              email: this.form.email,
              // platform_id: this.form.platform_id,
              screenshots: this.form.screenshots,
            }
          ).then(res => {
            this.$parent.changeStep(this.jumpMap[item.channel_type],this.form);
          }).catch(error => {
            this.$toast.fail((error && error.data && error.data.msg) || this.$t('networkErrorText'));
          }).finally(() => { this.submitting = false; });
       }else{
          this.$parent.changeStep(this.jumpMap[item.channel_type],this.form);
       }
      }else{
        this.$parent.changeStep('thanksAll',this.form);
      }
    },
  },
};
</script>

<style lang="scss">
.card-channelSelect {
  position: relative;
  width: 100%;
  .card-title {
    font-size: 23px;
    font-weight: 500;
    color: #1a1a1a;
    margin-bottom: 20px;
  }
  .card-text {
    font-size: 16px;
    font-weight: 400;
    color: #1a1a1a;
    margin-bottom: 20px;
  }
  .card-swipe {
    position: relative;
    margin-bottom: 10px;
    border-radius: 8px;
    .van-swipe {
      border-radius: 8px;
    }
  }
  .card-swipe .van-swipe-item {
    width: 100%;
    border-radius: 8px;
  }

  .card-image {
    width: 100%;
    height: 100%;
    border-radius: 8px;
  }

  .card-footer {
    padding: 10px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }

  .footer-note {
    font-size: 15px;
    color: #777;
    margin-bottom: 10px;
  }

  .swipe-arrow {
    width: 28px;
    border: none;
    height: 28px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    color: #000;
    font-size: 23px;
    background-color: #ffd814;
    padding: 0;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
    cursor: pointer;
    border-radius: 2px;
  }

  .prev-arrow {
    left: 6px;
  }

  .next-arrow {
    right: 6px;
  }

  .van-swipe__indicator .van-swipe__indicator-item {
    background-color: #fff;
  }

  .van-swipe__indicator .van-swipe__indicator-item--active {
    background-color: #f4a300; /* 高亮颜色 */
  }
  .van-swipe__track {
    display: flex;
    align-items: center;
  }
  .van-swipe {
    border: 1px solid #f4a300;
    // background: linear-gradient(180deg, rgba(245, 200, 0, 0.6666666667), #ffa031);
    background: #fff;
  }
}
</style>
